import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { ActivityOutcome, StandardIds } from '@galaxy/crm/static';
import { StaticSelectorService } from '../../../../../data-services/static-selector.service';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';

const callOutcomeChoices = new Map<string, string>([
  [ActivityOutcome.Demo, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.DEMO'],
  [ActivityOutcome.Interested, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.INTERESTED'],
  [ActivityOutcome.NoInterest, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.NO_INTEREST'],
  [ActivityOutcome.QualityConnect, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.QUALITY_CONNECT'],
  [ActivityOutcome.Rescheduling, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.RESCHEDULING'],
  [ActivityOutcome.Referred, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.REFERRED'],
  [ActivityOutcome.Timeline, 'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.TIMELINE'],
]);

@Component({
  selector: 'automata-modify-crm-call-activity-panel',
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyAlertModule,
    MatButtonModule,
    AutomationReplacementChipsComponent,
  ],
  templateUrl: './modify-crm-call-activity-panel.component.html',
  styleUrl: './modify-crm-call-activity-panel.component.scss',
})
export class ModifyCrmCallActivityPanelComponent extends CommonActionPanelComponent implements OnInit {
  public callOutcomeFieldId = StandardIds.ActivityCallOutcome;
  public callOutcomeService = new StaticSelectorService(callOutcomeChoices, this.translateService);
  public form: UntypedFormGroup;

  constructor() {
    super();
    this.form = new UntypedFormGroup({
      [this.callOutcomeFieldId]: new FormControl<string | null>(null),
    });
  }

  ngOnInit(): void {
    super.ngOnInit();

    const jsonData = this.step ? JSON.parse(this.step.data) : { fields: [] };

    for (const c in this.form.controls) {
      this.form.controls[c].setValue(jsonData?.fields[c] || null);
    }
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step?.data ?? '') : {};
    const fields = {};
    for (const c in this.form.controls) {
      fields[c] = this.form.controls[c].value;
    }
    jsonData.fields = fields;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.form];
  }

  isFormValid(): boolean {
    return this.form.valid;
  }
}
